import { render, staticRenderFns } from "./ota-upload.vue?vue&type=template&id=fe9dff54&"
import script from "./ota-upload.vue?vue&type=script&lang=ts&"
export * from "./ota-upload.vue?vue&type=script&lang=ts&"
import style0 from "./ota-upload.vue?vue&type=style&index=0&id=fe9dff54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports